<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="formData.name"
            label="Name"
            class="mr-2"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" sm="3">
          <v-checkbox
            v-model="formData.completed"
            v-show="action == 'Edit'"
            label="Completed"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formData.completionDate"
                :label="formData.completed ? 'Completion Date' : 'Due Date'"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                :disabled="savingForm == true"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.completionDate"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :disabled="action == 'Edit'"
            label="Estimated Hours"
            prepend-icon="mdi-timer-sand"
            v-model="formData.estimatedHours"
            @keypress="isNumber($event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            filled
            label="Description"
            auto-grow
            v-model="formData.description"
            :disabled="savingForm == true"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            v-model="formData.team"
            :items="this.userNames"
            hide-selected
            hint="Click to add team members"
            label="Assigned"
            multiple
            clearable
            disable-lookup
            small-chips
            deletable-chips
          >
          </v-select>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "TaskForm",
  props: ["userid", "data", "savingForm", "action"],
  data: () => ({
    formData: {
      name: null,
      completionDate: null,
      completed: false,
      team: [],
      teamIds: []
    },
    userNames: [],
    userIds: [],
    dateMenu: false
  }),
  computed: {
    clientStoreData() {
      return this.$store.getters.getClients;
    },
    userStoreData() {
      return this.$store.getters.getUsers;
    },
    projectStoreData() {
      return this.$store.getters.getProjects;
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
    validForm() {
      return (
        this.formData.name !== null &&
        this.formData.name !== "" &&
        this.formData.name !== undefined &&
        this.formData.completionDate !== null &&
        this.formData.completionDate !== "" &&
        this.formData.completionDate !== undefined &&
        this.formData.completed !== null &&
        this.formData.completed !== "" &&
        this.formData.completed !== undefined &&
        this.formData.estimatedHours !== null &&
        this.formData.estimatedHours !== "" &&
        this.formData.estimatedHours !== undefined &&
        this.formData.description !== null &&
        this.formData.description !== "" &&
        this.formData.description !== undefined &&
        this.formData.team.length > 0 &&
        (this.action != "Edit" ||
          this.formData.name != this.data.name ||
          this.formData.completionDate != this.data.completionDate ||
          this.formData.completed != this.data.completed ||
          this.formData.description != this.data.description ||
          this.formData.team.length != this.data.team.length ||
          this.formData.estimatedHours != this.data.estimatedHours)
      );
    },
    companyId() {
      return this.$store.getters.getCompanyId;
    }
  },
  watch: {
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.formData.teamIds = [];
        for (var id of this.userIds) {
          let user = JSON.parse(JSON.stringify(this.userStoreData[id].name));
          for (var name of this.formData.team) {
            if (name == user) {
              this.formData.teamIds.push(id);
            }
          }
        }
        this.$emit("loading", this.action.trimRight("e") + "ing Task...");
        if (this.action == "Add") {
          this.addTask();
        } else if (this.action == "Edit") {
          this.editTask();
        } else if (this.action == "Delete") {
          this.deleteTask();
        }
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit("valid-form", true);
      } else {
        this.$emit("valid-form", false);
      }
    },
    companyId() {
      this.formData.companyId = this.companyId;
    }
  },
  _methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getChangedData() {
      let changedData = {};
      let oldData = this.data;
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key];
        }
      }

      return changedData;
    },
    editTask() {
      let self = this;
      self.$store
        .dispatch("editTask", {
          id: self.data.id,
          changedData: self.getChangedData()
        })
        .then(result => {
          if (result.success != true) {
            self.$emit("error", result.data.error.message);
          } else {
            self.$emit("success", "Successfully edited task!");
            self.$emit("update-table", {
              action: "edit",
              item: result.data
            });
          }
        });
    },
    deleteTask() {
      let self = this;
      // if (self.userAdmin == true) {
      //   self.$store.dispatch("deleteTask", self.formData.id).then(result => {
      //     if (result.success != true) {
      //       self.$emit("error", result.data.error.message);
      //     } else {
      //       self.$emit("success", "Successfully deleted task!");
      //       self.$emit("update-table", {
      //         action: "delete"
      //       });
      //     }
      //   });
      // } else {
      self.$emit("error", "Unable to delete task.");
      //}
    },
    addTask() {
      let self = this;
      this.formData.companyId = this.companyId;
      self.$store.dispatch("submitTask", self.formData).then(result => {
        if (result.success != true) {
          self.$emit("error", result.data.error.message);
        } else {
          self.$emit("success", "Successfully added task!");
          self.$emit("update-table", {
            action: "add",
            item: result.data
          });
        }
      });
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
  mounted() {
    if (this.data != null) {
      this.formData.serviceType = this.data.serviceType;
      this.formData.projectId = this.data.projectId;
      if (this.action == "Edit") {
        this.formData = JSON.parse(JSON.stringify(this.data));
        let userList = [];
        for (var tId of this.formData.team) {
          userList.push(this.userStoreData[tId].name);
        }
        this.formData.team = userList;
        this.formData.teamIds = [];
      }
    }
    this.userNames = [];
    this.userIds = [];
    for (var userId of this.projectStoreData[this.formData.projectId].team) {
      let user = JSON.parse(JSON.stringify(this.userStoreData[userId].name));
      this.userNames.push(user);
      this.userIds.push(userId);
    }
  }
};
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
